module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "Minion-Bold"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgments"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('a', {
    attrs: {
      "href": "#/key"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Key to Symbols")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Best Films of 2011")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#b1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Best Documentaries of 2011")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Interviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#b2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Asghar Farhadi "), _c('em', [_vm._v("(A Separation)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#b3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Tilda Swinton "), _c('em', [_vm._v("(We Need to Talk About Kevin)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#b4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Quvenzhane Wallis "), _c('em', [_vm._v("(Beasts of the Southern Wild)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Ebert’s Journal")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Sarah Palin Documentary")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Enigma of Political Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("A   Shimmering Mirage")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Knocked Up At the Movies")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Sudden Death of Film")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Heteronormative Vampires")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Dissecting Declining Box Office Revenue")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Think of Me as the Butler, Carson")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Oscar Losers: They Wuz Robbed")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Indie Spirit Awards Joined "), _c('em', [_vm._v("The Artist")]), _vm._v(" Bandwagon")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Hey, Kids! Anybody Here Not Heard the F-Word?")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_c('em', [_vm._v("The Raid")]), _vm._v(" and Why I Hated It")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("I Remember You")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Perfect Audience")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Movies Don’t Stream Themselves")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("A Few Calm Words About The List")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("In Memoriam")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#b21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Andrew Sarris")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Film Festival")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#b22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Toronto International Film Festival")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Ebert’s Little Movie Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-980d9f98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 66
// module chunks = 0